import { render, staticRenderFns } from "./comp_AppBar-Bottom.vue?vue&type=template&id=246d56da&scoped=true&"
import script from "./comp_AppBar-Bottom.vue?vue&type=script&lang=js&"
export * from "./comp_AppBar-Bottom.vue?vue&type=script&lang=js&"
import style0 from "./comp_AppBar-Bottom.vue?vue&type=style&index=0&id=246d56da&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246d56da",
  null
  
)

export default component.exports